import { render } from "./Orders.vue?vue&type=template&id=128b7ebd&scoped=true"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"

import "./Orders.vue?vue&type=style&index=0&id=128b7ebd&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-128b7ebd"

export default script